import { render, staticRenderFns } from "./AddClient.vue?vue&type=template&id=4f6d504a&scoped=true&"
import script from "./AddClient.vue?vue&type=script&lang=ts&"
export * from "./AddClient.vue?vue&type=script&lang=ts&"
import style0 from "./AddClient.vue?vue&type=style&index=0&id=4f6d504a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6d504a",
  null
  
)

export default component.exports